<template>
  <div class="yxtbiz-tag-group">
  <yxt-tag :effect="getPlain(tag)" class="hand" @click="select(tag)" v-for="tag in data" :key="tag.id" :type="getType(tag)">
    <span class="yxtbiz-tag-selected-icon" v-if='multi'>
      <yxt-svg width='14px' height='14px' class="color-primary-6 v-top" icon-class='pick'></yxt-svg>
    </span>
    <span class="color-gray-9">{{ tag.tagName }}</span>
  </yxt-tag>
  </div>
</template>

<script>
import { Tag } from 'yxt-pc';
export default {
  components: {
    YxtTag: Tag
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    groupId: {
      type: String
    },
    multi: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: this.value
    };
  },
  computed: {
    ids() {
      return this.data.map(tag => tag.id);
    }
  },
  methods: {
    getType(tag) {
      return this.selected.find(item => item.id === tag.id) ? '' : 'info';
    },
    getPlain(tag) {
      return this.selected.find(item => item.id === tag.id) ? 'plain' : 'light';
    },
    select(tag) {
      let checked = !!this.value.find(item => tag.id === item.id);

      if (checked) {
        // 取消选择
        this.selected = this.selected.filter(item => item.id !== tag.id);
      } else {
        // 选中
        if (!this.multi) {
          // 单选， 先清除同一个groupId所有选中
          this.selected = this.selected.filter(item => !this.ids.includes(item.id));
        }
        this.selected.push(tag);
      }

      this.$emit('input', this.selected);
    }
  },
  watch: {
    value(v) {
      this.selected = v;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>